import React, { lazy, Suspense } from "react";
import { FooterHandler } from "./Footer/Footer";
import './nav_bar.css'
import { Button, Col, Row, Spin } from "antd";
import './landing.css'
import lasermet from "../assets/Logo/lasermet.png"
import EmblaCarousel from "./EmblaCarousel";
import { NavLink, useNavigate } from "react-router-dom";
import useAuth from '../routes/useAuth'
import LandingPageNavbar from "./LandingPageNavbar";
import { useTranslation } from "react-i18next";
import { useRef } from "react";
const ReactPlayer = React.lazy(() => import("react-player"));
// import Printable from "../pages/Loginv2/Calculators/Results/Printable/Printable";
// import useGeneratePDF from '../customHooks/useGeneratePDF'

export function LandingPage() {
    const { isFetching, isVerified } = useAuth()
    const navigate = useNavigate()
    const { t } = useTranslation()

    const componentRefToPrint = useRef(null)
    // const { reactToPrint } = useGeneratePDF(componentRefToPrint)



    return (
        <>
            {/* <Printable ref={componentRefToPrint} />
            <Button onClick={reactToPrint}>Print Sample</Button> */}
            <LandingPageNavbar />
            <Row className='background' style={{ minHeight: "100vh", display: "flex", backgroundImage: "url('/images/Pink-Gradientv1.webp')" }}>
                <Row className="content1" style={{ width: "100%", maxWidth: "1280px" }} gutter={[0, 32]}>
                    <Col className="info-group1" xl={12} sm={24} style={{ justifySelf: "center" }}>
                        <h1>
                            {t('50001')}
                        </h1> {/** Online Laser Safety Calculation Software to IEC 60825-1 */}
                        <div className="space" />
                        <div style={{ width: "90%" }}>
                            <h6>
                                {t('50002')}
                            </h6> {/** Realtime LSS is the easy-to-use online laser safety calculator, fully compliant with international standard IEC 60825-1: Safety of Laser Products - Part 1. */}
                            <div className="space" />
                            <div className="button-group">
                                <Col lg={11} md={11} xs={20} sm={20}>
                                    {/* <NavLink to="/login"> */}
                                    <Button className="mainButton" type="primary"
                                        onClick={() => {
                                            if (isVerified) {
                                                navigate('/home', { state: { fromWelcomePage: true } })
                                            } else {
                                                navigate('/login')
                                            }
                                        }}
                                        style={{ fontWeight: "500" }}
                                    >
                                        {t('50003')}
                                    </Button> {/** Try it Now */}
                                    {/* </NavLink> */}
                                </Col>

                                <Col lg={11} md={11} xs={20} sm={20}>
                                    <NavLink to="/pricing-landing">
                                        <Button className="mainButton" style={{ backgroundColor: "white", color: "#1D1F8C", fontWeight: "500" }}>
                                            {t('50004')}
                                        </Button> {/** View Pricing */}
                                    </NavLink>
                                </Col>
                            </div>

                        </div>
                    </Col>
                    <div className="embla-space" />
                    <Col xl={12} sm={24}>
                        <EmblaCarousel />
                    </Col>
                </Row>
            </Row>

            <Row className="content2" style={{ width: "100%", maxWidth: "1280px", height: "auto", display: "flex", backgroundColor: "white", justifyContent: "center", justifySelf: "center" }}>

                <Col xl={14} sm={24} xs={24}>
                    <div className='player-wrapper' style={{ justifyItems: "center", }}>
                        <Suspense fallback={<div style={{ height: 411 }}><Spin /></div>}>
                            <ReactPlayer
                                className='react-player'
                                url="https://www.youtube.com/watch?v=AuJb3WLqDW8"
                                controls
                                width={780}
                                height={411}
                                style={{ maxWidth: "100%" }}
                            />
                        </Suspense>
                    </div>
                </Col>
                <Col xl={10} sm={24} xs={24} style={{ padding: "24px", marginTop: "-40px" }}>
                    {/* <img src={logo} alt='Realtime LSS logo' width={400} /> */}
                    <div style={{ justifyContent: "center", margin: "40px 0 0 0" }}>
                        <p>{t('50005')}</p> {/** RealTime LSS provides on-the-go access, making it ideal for quick assessments whether in the lab or in the field. */}
                    </div>
                    <div style={{ margin: "15px 0px 15px 0px" }}>
                        <p>{t('50006')}:</p> {/** Calculate important laser safety parameters, including: */}
                    </div>
                    <div style={{ padding: "0px 0px 0px 8px" }}>
                        <ul class="custom-ul">
                            <li>
                                {t('50007')} {/**  Maximum Permissible Exposure (MPE) calculation */}
                            </li>
                            <li>
                                {t('50008')} {/**  Accessible Emission Limits (AEL) calculation */}
                            </li>
                            <li>
                                {t('50009')} {/**  Laser Classification */}
                            </li>
                            <li>
                                {t('50010')} {/**  Diffuse Reflection calculations */}
                            </li>
                            <li>
                                {t('50011')} {/** Fiber Optic Assessments */}
                            </li>
                        </ul>
                    </div>
                    <Button type="primary" href="/login" style={{ borderRadius: "0px", width: "40%", marginTop: "20px", textDecoration: "none" }}>
                        {t('50003')}
                    </Button> {/** Try it now */}
                </Col>
            </Row>

            <Row style={{ width: "100%", maxWidth: "1280px", height: "auto", backgroundColor: "white", justifyContent: "center", display: "flex", justifySelf: "center", paddingTop: "144px" }}>
                <div style={{ paddingRight: "16px" }}>
                    <img src={lasermet} alt="Lasermet logo" width={300} loading="lazy" />
                </div>

                <div className="RTLSSbox">
                    <div>
                        {t('50012')}
                    </div> {/** RealTime LSS is developed by Lasermet, a globally recognized authority in laser safety. With decades of experience in laser safety standards, consultancy, and technology. Lasermet provides trusted solutions for ensuring compliance with IEC-60825-1 and other international regulations. */}
                    <Row style={{ marginTop: "20px" }}>
                        <Col xl={10}>

                        </Col>
                        <Col xl={14}>
                            <Button href={"https://www.lasermet.com/"} target="_blank" style={{ textDecoration: "none", borderColor: "#1D1F8C", color: "#1D1F8C", borderRadius: "0px", backgroundColor: "transparent", }}>
                                {t('50013')}
                            </Button> {/** Visit Lasermet */}

                        </Col>
                    </Row>
                </div>

            </Row>
            <FooterHandler />
        </>
    )
}


